import { ModalsModule } from '../extensions/ModalsExtensions';

// Same list as in https://github.com/wix-private/premium/blob/800052510d9b6c594afeff5493f51314c57a5b0b/premium-server/premium-common-modules/premium-common/src/main/scala/com/wixpress/premium/common/RestrictedDomainChecker.scala
const GOOGLE_RESTRICTED_WORDS = ['adsense', 'adwords', 'google', 'go0gle', 'g0ogle', 'g00gle', 'gmail', 'appspot', 'blogspot', 'blogger', 'youtube'];
export const useGoogleRestrictedWordCheck = () => {
  const googleRestrictedWordModal = ModalsModule.internals.domainsActionsModalsController.googleRestrictedWord;
  const checkGoogleRestrictedWord = _ref => {
    let {
      domainName
    } = _ref;
    const domainLower = domainName.toLowerCase();
    const hasRestrictedWord = GOOGLE_RESTRICTED_WORDS.some(word => domainLower.includes(word));
    if (hasRestrictedWord) {
      googleRestrictedWordModal.show({
        domainName
      });
      return true;
    }
    return false;
  };
  return {
    checkGoogleRestrictedWord
  };
};
//# sourceMappingURL=useGoogleRestrictedWordCheck.js.map